var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("apexChart", {
        staticClass: "chart",
        attrs: {
          type: _vm.chartType,
          width: _vm.width,
          height: _vm.height,
          options: _vm.chartOptions,
          series: _vm.series
        },
        on: { dataPointSelection: _vm.handleDataPointSelection }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }